export enum VatTransactionType {
  SALE = "Продажа",
  PURCHASE = "Покупка",
}

export enum VatTransactionStatus {
  PENDING = "В ожидании",
  PARTIALLY_PAID = "Частично оплачено",
  PAID = "Оплачено",
  CANCELLED = "Отменено",
}

export interface IVatTransaction {
  _id: string;
  date: string;
  invoiceNumber: string;
  clientId: string;
  clientName: string;
  clientTin: string;
  transactionType: VatTransactionType;
  description: string;
  amountWithoutVat: { USD: number; TJS: number };
  vatAmount: { USD: number; TJS: number };
  totalAmount: { USD: number; TJS: number };
  exchangeRate: number;
  vatRate: number;
  status: VatTransactionStatus;
  paymentDate?: string;
  notes?: string;
  isPaid: boolean;
  paidAmount: { USD: number; TJS: number };
  createdAt: string;
  updatedAt: string;
} 